import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
import useTabParam from '../../hooks/useTabParam';
import CodDetails from "./CodDetails";
import CodConfig from "./CodConfig";
import PageTitle from "../../components/PageTitle";

function CourierCodReconTabs() {
    const [value, setValue] = useTabParam("1");
    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <PageTitle>Courier COD Reconcilation</PageTitle>
            <TabContext value={value}>
                <Box sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                    <TabList
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        sx={{
                            "& .MuiTab-root": {
                                px: 7,
                                py: 2,
                            },
                        }}
                    >
                        <Tab
                            iconPosition="top"
                            label="COD Details"
                            value="1"
                        />
                        <Tab
                            label="COD Config"
                            value="2"
                            iconPosition="top"
                        />
                    </TabList>
                </Box>
                <TabPanel value="1" sx={{ px: 0 }}>
                    <CodDetails />
                </TabPanel>
                <TabPanel value="2" sx={{ px: 0 }}>
                    <CodConfig />
                </TabPanel>
            </TabContext>
        </>
    );
}

// export default withLayout(CourierCodReconTabs);
export default CourierCodReconTabs;
